import { render, staticRenderFns } from "./PriceChange.vue?vue&type=template&id=3871f2ba&scoped=true"
import script from "./PriceChange.vue?vue&type=script&lang=js"
export * from "./PriceChange.vue?vue&type=script&lang=js"
import style0 from "./PriceChange.vue?vue&type=style&index=0&id=3871f2ba&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3871f2ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3871f2ba')) {
      api.createRecord('3871f2ba', component.options)
    } else {
      api.reload('3871f2ba', component.options)
    }
    module.hot.accept("./PriceChange.vue?vue&type=template&id=3871f2ba&scoped=true", function () {
      api.rerender('3871f2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobile/components/PriceChange.vue"
export default component.exports